import type { HTMLAttributes, ReactNode } from "react";

import { cn } from "@/lib/utils";

export interface ULThemeTitleProps extends HTMLAttributes<HTMLDivElement> {
  /**
   * The title of the screen.
   */
  children: ReactNode;
  /**
   * Optional class names for additional styling or overriding default styles.
   */
  className?: string;
}

const ULThemeTitle = ({ children, className, ...rest }: ULThemeTitleProps) => {
  const themedStyles =
    "mt-12 text-green-800 justify-text-header text-display-sm ";

  return (
    <h1 className={cn(themedStyles, className)} {...rest}>
      {children}
    </h1>
  );
};

export default ULThemeTitle;
